import React from 'react';
import LegalPage from './LegalPage';

export default function TermsAndCondition() {
  return (
    <LegalPage title="Terms & Conditions" lastUpdated="July 2026">
      
      <h2>1. Introduction & Acceptance of Terms</h2>
      <p>
        These Terms and Conditions ("Terms") govern your access to and use of the services, website, and digital products provided by <strong>Bombay Coding Consultancy LLP</strong> (operating as "Bombay Coding Company," "we," "us," or "our"). 
        By accessing our website, opting into our lead forms, or engaging us for software development, design, SaaS engineering, or AI integration services, you ("Client," "User," or "you") agree to be bound unconditionally by these Terms.
      </p>

      <h2>2. Provision of Services & Scope</h2>
      <p>
        Bombay Coding Company operates as a premium MERN-stack and AI software studio. The scope of any specific project, including timelines, deliverables, and service boundaries, shall be governed by a separate Statement of Work (SOW) or Master Services Agreement (MSA) signed between the Client and us.
        We reserve the right to modify or suspend access to our public website or platform features without prior notice for maintenance, continuous innovation, or security purposes.
      </p>

      <h2>3. Intellectual Property Rights & Transfer</h2>
      <p>
        All preliminary code, design prototypes, proprietary frameworks, and tools used by Bombay Coding Company during the development lifecycle remain the exclusive intellectual property of Bombay Coding Consultancy LLP.
      </p>
      <ul>
        <li><strong>Client IP Guarantee:</strong> Upon full and final clearance of all invoice payments related to a specific project milestone, copyright and intellectual property rights for the custom developed frontend and backend code files are automatically transferred to the Client.</li>
        <li><strong>Base Frameworks:</strong> Any pre-existing open-source libraries, React templates, or underlying boilerplate architectures used to accelerate development remain subject to their respective MIT/Apache licenses or remain our property, licensed perpetually to the Client for use within the final product.</li>
      </ul>

      <h2>4. Client Responsibilities & Dependencies</h2>
      <p>
        The timely delivery of software relies directly on the Client's prompt feedback. The Client agrees to provide necessary access credentials, hosting environments, and feedback within the timelines stated in their respective SOW. Failure to do so may result in timeline extensions or scope renegotiation.
      </p>

      <h2>5. Warranties & Liability Limitation</h2>
      <p>
        We build robust and secure software architectures using industry best practices. However, Bombay Coding Company provides its public website and services on an "AS IS" and "AS AVAILABLE" basis. 
      </p>
      <ul>
        <li><strong>Third-Party Outages:</strong> We shall not be held liable for downtime, data loss, or damages resulting from third-party API failures (e.g., AWS, Vercel, MongoDB Atlas, OpenAI architectures).</li>
        <li><strong>AI Output Disclaimer:</strong> For projects involving Generative AI or LLM integration, we do not guarantee the factual accuracy, copyright safety, or predictability of outputs generated by third-party AI models.</li>
        <li><strong>Damage Cap:</strong> In no event shall Bombay Coding Consultancy LLP, its partners, or developers be held liable for indirect, incidental, or consequential damages. Our total liability for any claim arising out of our services shall not exceed the total fees paid by the Client for the specific project milestone that gave rise to the claim.</li>
      </ul>

      <h2>6. Governing Law & Dispute Resolution</h2>
      <p>
        These Terms shall be governed by, construed, and enforced in accordance with the laws of <strong>India</strong> (and the Information Technology Act, 2000). 
        You irrevocably agree that the state and federal courts located within the jurisdiction of <strong>Mumbai, Maharashtra (India)</strong> shall have exclusive jurisdiction to settle any dispute or claim that arises out of or in connection with these Terms or your engagement of our services.
      </p>

      <h2>7. Contact Information</h2>
      <p>
        If you have any questions or concerns regarding these Terms and Conditions, please contact us directly at our headquarters:<br />
        <strong>Bombay Coding Consultancy LLP</strong><br />
        1/11, Sai Skrupa Seva Society, Ghartan Pada No. 2,<br />
        Suyog Nagar, Sant Mirabai Marg, Dahisar East, Mumbai – 400068
      </p>
    </LegalPage>
  );
}
